import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleItem } from '../../api/models';
import { enumUserRole } from '../models/enum-user-role';

@Pipe({ name: 'showRole' })
export class DisplayRolePipe implements PipeTransform {
  transform(role: UserRoleItem, ...args: boolean[]): string {
    switch (role.id) {
      case enumUserRole.ADMINISTRATOR:
        return args && args[0] === true
          ? `<div class="badge-container muted-g-bg">Administrator <i class="pi pi-pencil"></<i></div>`
          : 'Administrator';
      case enumUserRole.UTENTE:
        return args && args[0] === true
          ? `<div class="badge-container muted-t-bg">Traveler <i class="pi pi-pencil"></<i></div>`
          : 'Traveler';
      case enumUserRole.TOURLEADER:
        return args && args[0] === true
          ? `<div class="badge-container muted-o-bg">Tour Leader <i class="pi pi-pencil"></<i></div>`
          : 'Tour Leader';
      case enumUserRole.TOURLEADER_PRO:
        return args && args[0] === true
          ? `<div class="badge-container muted-s-bg">Tour Leader Pro <i class="pi pi-pencil"></<i></div>`
          : 'Tour Leader Pro';
    }
    throw new Error("La showRolePipe non riconosce il ruolo")
  }
}
